export const domainNamePattern = /^[a-z0-9-_]*$/;
